module.exports = __webpack_public_path__ + "img/restaurant-1.45b60581.jpg";